import { RootState } from '@store/store';

export const authSelectors = {
  isAuthenticated: (state: RootState) => Boolean(state?.auth?.isAuthenticated),
};
